import React from 'react';

import {
  FooterPanelContainer,
  PanelGroup,
  TablePagination,
} from '../../../UiComponentsLibrary/UDC';

interface UDCTableFooterPanelProps {
  pageSizes?: number[];
  hideOnSinglePage?: boolean;
}

/**
 * Reusable footer panel component for UDC tables
 * Provides pagination functionality with configurable page sizes
 * @param pageSizes - Array of available page size options (default: [10, 20, 50, 100])
 * @param hideOnSinglePage - Whether to hide pagination when only one page exists (default: false)
 * @returns JSX element containing the footer panel with pagination
 */
const UDCTableFooterPanel = ({
  pageSizes = [10, 20, 50, 100],
  hideOnSinglePage = false,
}: UDCTableFooterPanelProps) => {
  return (
    <FooterPanelContainer>
      <PanelGroup align="end">
        <TablePagination
          pageSizes={pageSizes}
          hideOnSinglePage={hideOnSinglePage}
        />
      </PanelGroup>
    </FooterPanelContainer>
  );
};

export default UDCTableFooterPanel;